// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2YrbL","expireSoon":"styles_expireSoon__3Aem9"};